module.exports = __webpack_public_path__ + "static/assets/ab3d8c9cb32a2f96a38495fa2165da46.svg";